import React, {Component} from 'react'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BankStatementsCollectUI from './BankStatementsCollectUI'

class BankStatementsCollectSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      bankStatements: [],
    }
  }

  render() {
    return (
      <BankStatementsCollectUI
        context={this.props.context}
        errorList={this.state.errorList}
        onProceedClick={this.onProceedClick}

        bankStatements={this.state.bankStatements}
        onBSUploadClick={this.onBSUploadClick}

      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onBSUploadClick = (file) => {
    console.log("onBSUploadClick", file);
    let submitted = this.state.submitted
    if (submitted)
      return
    this.setState({submitted: true, errorList: null})

    this.getFileUploadSignedUrl(file)
  }

  getFileUploadSignedUrl(file) {
    let context = this.props.context
    let getResource = `${RestApiUtils.getServerUrl(context)}/api/accounts/${this.props.context.session.accountId}/bankStatementURL` +
      `?fileName=${file.name}&type=${file.type}&size=${file.size}`
    console.log('-> GET', getResource)

    fetch(getResource, {
      headers: RestApiUtils.getHeaders(context),
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('<- GET', getResource, json)
        if (json.errorList.length)
          this.setState({submitted: false, errorList: json.errorList})
        else
          this.uploadFile(json.signedUrl, file)
      })
  }

  uploadFile = (signedUrl, file) => {
    let putResource = signedUrl
    console.log('-> PUT', putResource)
    fetch(putResource, {
      method: 'put',
      body: file,
    })
      .then((response) => {
        console.log('<- PUT', putResource)
        this.onFileUploadCallback(response, signedUrl, file)
      })
  }

  onFileUploadCallback = (response, signedUrl, file) => {
    console.dir(response)
    console.dir(signedUrl)
    console.dir(file)

    let bankStatements = this.state.bankStatements;

    bankStatements.push(file.name);

    this.setState({
      bankStatements: bankStatements,
    })

  }

  onProceedClick = () => {
    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/accounts/${context.session.accountId}/loans`,
      this.onProceedCallback, {}
    )
  }

  onProceedCallback = (response) => {
    if (response.errorList.length === 0) {
      window.location.href = '/loans/' + response.loan.path + "/" + response.loan.loanId;
    }
  }

}

export default BankStatementsCollectSF
